import React from 'react'
import MobileLayout from '../../MobileLayout'
import Text from '../../atoms/Text'
import { kidneyScorecardsData } from '../../../common/const'

const KidneyScoreSheet = () => {
  return (
    <MobileLayout>
      <div className="p-4 mt-11 lg:px-12 lg:pt-10 lg:pb-8 lg:mt-0 lg:max-w-3xl lg:mx-auto">
        <div className="flex flex-col gap-4">
          <Text variant="display" size="large" tag="p">
            Your Kidney Health Score
          </Text>
          <Text variant="body" size="large">
            Your Kidney Health Score is a comprehensive assessment designed to
            evaluate your kidney function and potential risk for Chronic Kidney
            Disease (CKD). This score is based on key health parameters,
            lifestyle factors, and clinical markers that reflect your kidney's
            ability to function optimally.
          </Text>
        </div>
        <div className="mt-10">
          <Text variant="display" size="large">
            Score Categories
          </Text>
          <div className="space-y-6 mt-4">
            {kidneyScorecardsData?.map((card, idx) => {
              const { header, descriptions } = card
              return (
                <div
                  key={`${header.title}__${idx}`}
                  className="px-4 pt-4 pb-15 rounded-3 space-y-5 bg-background-secondary overflow-hidden relative"
                >
                  <div className="flex items-center gap-3">
                    <div className="relative h-10 w-10">
                      <img
                        src={header.icon}
                        alt={header.title}
                        height={40}
                        width={40}
                      />
                    </div>
                    <Text
                      tag="p"
                      variant="headline"
                      size="small"
                      className="text-text-primary"
                    >
                      {header.title}
                    </Text>
                  </div>
                  {descriptions?.map((item, index) => (
                    <div
                      key={`${item.title}__${index}`}
                      className="relative z-10"
                    >
                      <div>
                        <Text
                          tag="p"
                          variant="title"
                          size="small"
                          className="text-text-primary"
                        >
                          {item.title}
                        </Text>
                        <Text
                          tag="p"
                          variant="body"
                          size="medium"
                          className="text-text-quartenary mb-[60px] mt-4"
                        >
                          {item.desc}
                        </Text>
                      </div>
                    </div>
                  ))}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </MobileLayout>
  )
}

export default KidneyScoreSheet
